/**
 * 一覧のスクロールの高さ（画面の高さに合わせる）
 *
 * Tailwind がクラス名を拾えるよう、クラス文字列のまま持つ。
 */

/**
 * 食事シート（画面の 92%）の中で、一覧を残りの高さいっぱいまで伸ばす。
 * 見出し・タブ（検索 / AI / お気に入り / 履歴 / DB）・検索欄・下の帯のぶん（約 21rem）を引き、小さい画面でも 10rem は確保する
 */
export const SHEET_LIST_MAX_HEIGHT = 'max-h-[max(10rem,calc(92dvh-21rem))]'

/** ページに置く記録バーの候補一覧（画面の半分まで） */
export const PAGE_LIST_MAX_HEIGHT = 'max-h-[50dvh]'
